import { Option } from '../../declarations/common/option';

const YesNoOptions: Option<'Yes' | 'No'>[] = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
];

export default YesNoOptions;